var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm._t(
        "default",
        function () {
          return [
            _c("UIButton", {
              attrs: {
                processing: _vm.processing,
                id: "uploadFile",
                label: "add black",
                buttonClass: "customAdd",
                buttonText: _vm.getButtonText,
              },
              on: { click: _vm.addFile },
            }),
          ]
        },
        {
          handleFileUpload: _vm.addFile,
          processing: _vm.processing,
          addFile: _vm.addFile,
          removeFile: _vm.removeFile,
          uploadFile: _vm.upload,
        }
      ),
      _c("input", {
        ref: "fileInput",
        staticClass: "hidden",
        attrs: { name: "upload", type: "file", tabindex: "0" },
        on: {
          change: _vm.fileChange,
          click: function ($event) {
            $event.stopPropagation()
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }